import { downloadFile } from 'api/utils/downloadFile';

import { registerResponseInterceptor } from '../api';

registerResponseInterceptor((response) => {
  const contestDisposition = response?.headers?.['content-disposition'] || '';

  const isAttachment =
    contestDisposition?.includes('attachment') &&
    contestDisposition.includes('filename');

  if (isAttachment) {
    // eslint-disable-next-line no-console
    console.debug('[API] Download blob file');
    let fileName = contestDisposition
      .split(';')
      .find((el) => el.includes('filename'))
      .split('=')[1]
      .replaceAll('"', '');

    //@TODO campaigns/uploadNewCampaigns in move to server side
    if (fileName === 'CampaignsUploadPlain') {
      fileName = 'campaigns upload+links.csv';
    }

    const fileData = new Blob([response?.data], {
      type: `${response.headers?.['content-type']};charset=utf-8`,
    });

    const href = window.URL.createObjectURL(fileData);

    downloadFile(href, fileName);
  }

  return response;
}, 'Download blob file handler');
